import { motion } from 'framer-motion';
import { CyberClicker } from '../components/games/CyberClicker';
import { NeuralPath } from '../components/games/NeuralPath';
import { ArchDefender } from '../components/games/ArchDefender';

export function Games() {
    return (
        <div className="pt-32 pb-24 px-6 md:px-12 max-w-7xl mx-auto min-h-screen">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center mb-20"
            >
                <h1 className="text-5xl md:text-7xl font-black mb-6 text-white tracking-tighter">
                    UI <span className="text-emerald-500">PLAYGROUND</span>
                </h1>
                <p className="text-gray-400 text-lg md:text-xl font-mono tracking-widest uppercase max-w-2xl mx-auto">
                    Interactive engineering challenges & modular UI stress-tests.
                </p>
            </motion.div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
                <div className="space-y-12">
                    <section className="space-y-6">
                        <div className="flex items-center gap-4">
                            <span className="text-[10px] font-mono text-emerald-500/50 bg-emerald-500/10 px-2 py-1 rounded">0x01</span>
                            <h2 className="text-xl font-bold text-white uppercase tracking-widest">Cognitive Sync</h2>
                        </div>
                        <NeuralPath />
                    </section>

                    <section className="space-y-6">
                        <div className="flex items-center gap-4">
                            <span className="text-[10px] font-mono text-emerald-500/50 bg-emerald-500/10 px-2 py-1 rounded">0x02</span>
                            <h2 className="text-xl font-bold text-white uppercase tracking-widest">Reaction Matrix</h2>
                        </div>
                        <CyberClicker />
                    </section>
                </div>

                <div className="space-y-12 h-full">
                    <section className="space-y-6 h-full">
                        <div className="flex items-center gap-4">
                            <span className="text-[10px] font-mono text-emerald-500/50 bg-emerald-500/10 px-2 py-1 rounded">0x03</span>
                            <h2 className="text-xl font-bold text-white uppercase tracking-widest">System Defense</h2>
                        </div>
                        <div className="h-full">
                            <ArchDefender />
                        </div>
                    </section>
                </div>
            </div>

            {/* Bottom Status */}
            <div className="mt-20 py-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 opacity-30 font-mono text-[9px] uppercase tracking-[0.5em]">
                <div>Session_ID: PR_77_GAME_PLAYGROUND</div>
                <div>Physics_Engine: Framer_Motion_v11.x</div>
                <div>UI_Density: HIGH</div>
            </div>
        </div>
    );
}
